module.exports = __webpack_public_path__ + "img/lasource-15.472cc6a2.jpg";